<template>
	<AiAssistantFactory v-bind="aiAssistantProps" @valueChanged="updateValue" />
</template>

<script>
import WidgetFieldMixin from './WidgetFieldMixin';
import AiAssistantFactory from '@/components/CodeBlockAiTabs/AiAssistantFactory.vue';
export default {
	name: 'AIInputField',
	components: { AiAssistantFactory },
	props: {
		isRuntime: { type: Boolean },
		isReadOnly: { type: Boolean },
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},
	mixins: [WidgetFieldMixin],
	mounted() {
		this.textFieldValue = this.defaultValue || '';
	},
	data() {
		return {
			textFieldValue: '',
		};
	},
	methods: {
		updateValue(value) {
			this.value = value;
		},
	},
	computed: {
		aiAssistantProps() {
			return {
				apiUrl: this.field.source_url,
				allowFineTuningValue: this.fieldOptions.allowFineTuning.value,
				isRuntime: this.isRuntime,
				isReadOnly: this.isReadOnly,
				maxWords: this.fieldOptions.maxWords,
				placeholder: this.field.metadata.options.placeholder,
				autoSubmitPrefilled: !!this.field.metadata.options.auto_submit_prefilled?.enabled,
				promptPrefix: this.field.metadata.options.prompt_prefix,
				defaultValue: this.defaultValue,
				previousSteps: this.previousSteps,
				replaceInsertDataStringDict: this.replaceInsertDataStringDict,
				configurationsMappingBlocksUUIDs: this.configurationsMappingBlocksUUIDs,
			};
		},
	},
};
</script>
